import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=73aeff9c&"
import script from "./ReviewDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports